import React, { useEffect, useRef } from 'react'
import { spiralCoinsAnimation } from '@/assets/videos'
import {
  responsiveAdapter,
  responsiveAdapterVertical,
} from '@/utils/responsive'

interface VideoAnimationProps {
  style?: React.CSSProperties
}

export const VideoAnimation: React.FC<VideoAnimationProps> = ({ style }) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = videoRef.current
    if (video) {
      // Автозапуск видео при загрузке компонента
      const playVideo = async () => {
        try {
          await video.play()
        } catch {
          // Ignore video play errors
        }
      }

      // Обработчик для перезапуска видео при переходе в активное состояние
      const handleVisibilityChange = () => {
        if (!document.hidden && video) {
          video.currentTime = 0
          playVideo()
        }
      }

      document.addEventListener('visibilitychange', handleVisibilityChange)
      playVideo()

      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange)
      }
    }
  }, [])

  // Константы как в React Native версии, но увеличенные
  const PERCENTAGE_RELATIVE = 0.9
  const BASE_SIZE = 1000 // Увеличили еще больше для большего эффекта
  const videoWidth = responsiveAdapter(BASE_SIZE * PERCENTAGE_RELATIVE)
  const videoHeight = responsiveAdapterVertical(BASE_SIZE * PERCENTAGE_RELATIVE)

  return (
    <div
      className="video-animation-container"
      style={{
        position: 'absolute',
        left: 0, // Начинается с левой стороны
        right: 0, // Растягивается по ширине
        top: '28%',
        width: `${videoWidth}px`,
        height: `${videoHeight}px`,
        transform: `translateY(-${videoHeight / 2}px)`, // Сдвигаем вверх на половину высоты
        zIndex: 0,
        overflow: 'hidden',
        ...style,
      }}
    >
      {/* Оригинальное видео анимации спирали монет */}
      <video
        ref={videoRef}
        src={spiralCoinsAnimation}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '0',
        }}
        loop
        muted
        playsInline
        preload="auto"
        onError={(e) => {}}
      />

      {/* Медиа-запросы для адаптивности */}
      <style>{`
        /* Адаптивность для мобильных устройств */
        @media (max-width: 768px) {
          .video-animation-container {
            width: ${videoWidth * 0.8}px !important;
            height: ${videoHeight * 0.8}px !important;
            transform: translateY(-${(videoHeight * 0.8) / 2}px) !important;
          }
        }

        @media (max-width: 480px) {
          .video-animation-container {
            width: ${videoWidth * 0.6}px !important;
            height: ${videoHeight * 0.6}px !important;
            transform: translateY(-${(videoHeight * 0.6) / 2}px) !important;
          }
        }

        @media (max-width: 360px) {
          .video-animation-container {
            width: ${videoWidth * 0.5}px !important;
            height: ${videoHeight * 0.5}px !important;
            transform: translateY(-${(videoHeight * 0.5) / 2}px) !important;
          }
        }
      `}</style>
    </div>
  )
}
